import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  CompanyAcknowledgementResponse,
  CompanyAcknowledgementResponseArraySchema,
} from '../../models/acknowledgements.model';
import { SmartrService } from '../smartr.service';

@Injectable({
  providedIn: 'root',
})
export class CompanyAcknowledgementsApiService extends SmartrService {
  private readonly http = inject(HttpClient);

  getOutstanding(clientId: number, brokerageId: string): Observable<CompanyAcknowledgementResponse[]> {
    const url = `${this.getBaseUrl()}/outstanding/${clientId}`;
    return this.http
      .get<CompanyAcknowledgementResponse[]>(url, { headers: this.buildHeaders(brokerageId) })
      .pipe(
        this.verifyResponse(CompanyAcknowledgementResponseArraySchema),
        catchError((error: HttpErrorResponse) => throwError(() => error))
      );
  }

  acknowledge(
    companyAcknowledgementId: string,
    brokerageId: string
  ): Observable<{ acknowledged: boolean }> {
    const url = `${this.getBaseUrl()}/acknowledge`;
    const payload = { companyAcknowledgementId };

    return this.http
      .post(url, payload, { headers: this.buildHeaders(brokerageId), observe: 'response' })
      .pipe(
        map((response) => ({ acknowledged: response.status === 204 })),
        catchError((error: HttpErrorResponse) => throwError(() => error))
      );
  }

  download(companyAcknowledgementId: string, brokerageId: string): Observable<Blob> {
    const url = `${this.getBaseUrl()}/${companyAcknowledgementId}/download`;
    return this.http
      .get<Blob>(url, {
        headers: this.buildHeaders(brokerageId),
        responseType: 'blob' as 'json',
      })
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  private getBaseUrl(): string {
    // documentStore.baseUrl points at the gateway (e.g. .../documents), which strips its
    // upstream prefix and forwards everything to /api/* on the downstream service.
    return `${environment.documentStore.baseUrl}/company-acknowledgements`;
  }

  private buildHeaders(brokerageId: string): HttpHeaders {
    return new HttpHeaders({ 'smt-target-brokerage': brokerageId });
  }
}
